import { enrichArtistRow } from "../../utils/artistStoreDetails";

let mockArtistsData = [
  {
    "id": 1,
    "name": "Taylor Swift",
    "amazon_music_identifier": "B00157GJ20",
    "apple_identifier": "159260351",
    "deezer_identifier": "12246",
    "spotify_identifier": "06HL4z0CvFAxyc27GXpf02",
    "popularity": 96,
    "followers": 157322778,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebe2e8e7ff002a4afda1c7147e",
    "image_small": "https://i.scdn.co/image/ab6761610000f178e2e8e7ff002a4afda1c7147e",
    "email": "taylor.swift@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "06HL4z0CvFAxyc27GXpf02",
      "name": "Taylor Swift",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebe2e8e7ff002a4afda1c7147e"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178e2e8e7ff002a4afda1c7147e"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178e2e8e7ff002a4afda1c7147e"
        }
      ],
      "popularity": 96,
      "followers": {
        "total": 157322778
      }
    },
    "deezer_details": {
      "id": 12246,
      "name": "Taylor Swift",
      "nb_album": 20,
      "nb_fan": 99000000,
      "picture_small": "https://api.deezer.com/artist/12246/image",
      "picture_medium": "https://api.deezer.com/artist/12246/image",
      "picture_big": "https://api.deezer.com/artist/12246/image",
      "picture_xl": "https://api.deezer.com/artist/12246/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00157GJ20",
          "name": "Taylor Swift",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81F710q5Q3L.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 2,
    "name": "Bad Bunny",
    "amazon_music_identifier": "B01HFUTKDK",
    "apple_identifier": "1126808565",
    "deezer_identifier": "11662390",
    "spotify_identifier": "4q3ewBCX7sLwd24euuV69X",
    "popularity": 98,
    "followers": 116506571,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb81f47f44084e0a09b5f0fa13",
    "image_small": "https://i.scdn.co/image/ab6761610000f17881f47f44084e0a09b5f0fa13",
    "email": "bad.bunny@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "4q3ewBCX7sLwd24euuV69X",
      "name": "Bad Bunny",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb81f47f44084e0a09b5f0fa13"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17881f47f44084e0a09b5f0fa13"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17881f47f44084e0a09b5f0fa13"
        }
      ],
      "popularity": 98,
      "followers": {
        "total": 116506571
      }
    },
    "deezer_details": {
      "id": 11662390,
      "name": "Bad Bunny",
      "nb_album": 20,
      "nb_fan": 73500000,
      "picture_small": "https://api.deezer.com/artist/11662390/image",
      "picture_medium": "https://api.deezer.com/artist/11662390/image",
      "picture_big": "https://api.deezer.com/artist/11662390/image",
      "picture_xl": "https://api.deezer.com/artist/11662390/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B01HFUTKDK",
          "name": "Bad Bunny",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81IiwsLGc+L.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 3,
    "name": "The Weeknd",
    "amazon_music_identifier": "B00AB5FG1A",
    "apple_identifier": "479756766",
    "deezer_identifier": "4050205",
    "spotify_identifier": "1Xyo4u8uXC1ZmMpatF05PJ",
    "popularity": 98,
    "followers": 105000000,
    "image_big": "https://api.deezer.com/artist/4050205/image",
    "image_small": "https://api.deezer.com/artist/4050205/image",
    "email": "the.weeknd@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1Xyo4u8uXC1ZmMpatF05PJ",
      "name": "The Weeknd",
      "images": [],
      "popularity": 98,
      "followers": {
        "total": 105000000
      }
    },
    "deezer_details": {
      "id": 4050205,
      "name": "The Weeknd",
      "nb_album": 20,
      "nb_fan": 78750000,
      "picture_small": "https://api.deezer.com/artist/4050205/image",
      "picture_medium": "https://api.deezer.com/artist/4050205/image",
      "picture_big": "https://api.deezer.com/artist/4050205/image",
      "picture_xl": "https://api.deezer.com/artist/4050205/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00AB5FG1A",
          "name": "The Weeknd",
          "images": []
        }
      }
    }
  },
  {
    "id": 4,
    "name": "Drake",
    "amazon_music_identifier": "B000QJRIHS",
    "apple_identifier": "271256",
    "deezer_identifier": "",
    "spotify_identifier": "3TVXtAsR1Inumwj472S9r4",
    "popularity": 100,
    "followers": 111314441,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb4293385d324db8558179afd9",
    "image_small": "https://i.scdn.co/image/ab6761610000f1784293385d324db8558179afd9",
    "email": "drake@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "3TVXtAsR1Inumwj472S9r4",
      "name": "Drake",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb4293385d324db8558179afd9"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1784293385d324db8558179afd9"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1784293385d324db8558179afd9"
        }
      ],
      "popularity": 100,
      "followers": {
        "total": 111314441
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000QJRIHS",
          "name": "Drake",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/716OFRUIorL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 5,
    "name": "Ariana Grande",
    "amazon_music_identifier": "B004IUAQ9S",
    "apple_identifier": "412778295",
    "deezer_identifier": "10623843",
    "spotify_identifier": "66CXWjxzNUsdJxJ2JdwvnR",
    "popularity": 91,
    "followers": 111812339,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb766397ec42a573a53eb5fb87",
    "image_small": "https://i.scdn.co/image/ab6761610000f178766397ec42a573a53eb5fb87",
    "email": "ariana.grande@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "66CXWjxzNUsdJxJ2JdwvnR",
      "name": "Ariana Grande",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb766397ec42a573a53eb5fb87"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178766397ec42a573a53eb5fb87"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178766397ec42a573a53eb5fb87"
        }
      ],
      "popularity": 91,
      "followers": {
        "total": 111812339
      }
    },
    "deezer_details": {
      "id": 10623843,
      "name": "Ariana Grande",
      "nb_album": 20,
      "nb_fan": 78000000,
      "picture_small": "https://api.deezer.com/artist/10623843/image",
      "picture_medium": "https://api.deezer.com/artist/10623843/image",
      "picture_big": "https://api.deezer.com/artist/10623843/image",
      "picture_xl": "https://api.deezer.com/artist/10623843/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B004IUAQ9S",
          "name": "Ariana Grande",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/91X4T1syLaL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 6,
    "name": "Justin Bieber",
    "amazon_music_identifier": "B002F0BWIM",
    "apple_identifier": "320569549",
    "deezer_identifier": "",
    "spotify_identifier": "1uNFoZAHBGtllmzznpCI3s",
    "popularity": 97,
    "followers": 90912513,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebaf20f7db5288bce9beede034",
    "image_small": "https://i.scdn.co/image/ab6761610000f178af20f7db5288bce9beede034",
    "email": "justin.bieber@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1uNFoZAHBGtllmzznpCI3s",
      "name": "Justin Bieber",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebaf20f7db5288bce9beede034"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178af20f7db5288bce9beede034"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178af20f7db5288bce9beede034"
        }
      ],
      "popularity": 97,
      "followers": {
        "total": 90912513
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B002F0BWIM",
          "name": "Justin Bieber",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/91IFobK4HtL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 7,
    "name": "Ed Sheeran",
    "amazon_music_identifier": "B0015H24HO",
    "apple_identifier": "183313439",
    "deezer_identifier": "1059314",
    "spotify_identifier": "6eUKZXaKkcviH0Ku9w2n3V",
    "popularity": 88,
    "followers": 126461571,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebd55c95ad400aed87da52daec",
    "image_small": "https://i.scdn.co/image/ab6761610000f178d55c95ad400aed87da52daec",
    "email": "ed.sheeran@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "6eUKZXaKkcviH0Ku9w2n3V",
      "name": "Ed Sheeran",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebd55c95ad400aed87da52daec"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178d55c95ad400aed87da52daec"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178d55c95ad400aed87da52daec"
        }
      ],
      "popularity": 88,
      "followers": {
        "total": 126461571
      }
    },
    "deezer_details": {
      "id": 1059314,
      "name": "Ed Sheeran",
      "nb_album": 20,
      "nb_fan": 81000000,
      "picture_small": "https://api.deezer.com/artist/1059314/image",
      "picture_medium": "https://api.deezer.com/artist/1059314/image",
      "picture_big": "https://api.deezer.com/artist/1059314/image",
      "picture_xl": "https://api.deezer.com/artist/1059314/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0015H24HO",
          "name": "Ed Sheeran",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71Gnqo2kWGL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 8,
    "name": "Billie Eilish",
    "amazon_music_identifier": "B01A7VBHJ4",
    "apple_identifier": "1065981054",
    "deezer_identifier": "9617664",
    "spotify_identifier": "6qqNVTkY8uBg9cP3Jd7DAH",
    "popularity": 91,
    "followers": 126716003,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb4a21b4760d2ecb7b0dcdc8da",
    "image_small": "https://i.scdn.co/image/ab6761610000f1784a21b4760d2ecb7b0dcdc8da",
    "email": "billie.eilish@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "6qqNVTkY8uBg9cP3Jd7DAH",
      "name": "Billie Eilish",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb4a21b4760d2ecb7b0dcdc8da"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1784a21b4760d2ecb7b0dcdc8da"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1784a21b4760d2ecb7b0dcdc8da"
        }
      ],
      "popularity": 91,
      "followers": {
        "total": 126716003
      }
    },
    "deezer_details": {
      "id": 9617664,
      "name": "Billie Eilish",
      "nb_album": 20,
      "nb_fan": 86250000,
      "picture_small": "https://api.deezer.com/artist/9617664/image",
      "picture_medium": "https://api.deezer.com/artist/9617664/image",
      "picture_big": "https://api.deezer.com/artist/9617664/image",
      "picture_xl": "https://api.deezer.com/artist/9617664/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B01A7VBHJ4",
          "name": "Billie Eilish",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/51gFss9+ErL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 9,
    "name": "Bruno Mars",
    "amazon_music_identifier": "B00181MLFM",
    "apple_identifier": "278873078",
    "deezer_identifier": "",
    "spotify_identifier": "0du5cEVh5yTK9QJze8zA0C",
    "popularity": 94,
    "followers": 82922473,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebc7688aad1bf03986934d7e26",
    "image_small": "https://i.scdn.co/image/ab6761610000f178c7688aad1bf03986934d7e26",
    "email": "bruno.mars@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "0du5cEVh5yTK9QJze8zA0C",
      "name": "Bruno Mars",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebc7688aad1bf03986934d7e26"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178c7688aad1bf03986934d7e26"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178c7688aad1bf03986934d7e26"
        }
      ],
      "popularity": 94,
      "followers": {
        "total": 82922473
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00181MLFM",
          "name": "Bruno Mars",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81gJPy2o4RL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 10,
    "name": "Coldplay",
    "amazon_music_identifier": "B000QKGN8W",
    "apple_identifier": "471744",
    "deezer_identifier": "892",
    "spotify_identifier": "4gzpq5DPGx6KlJUAGlLeqs",
    "popularity": 91,
    "followers": 58000000,
    "image_big": "https://api.deezer.com/artist/892/image",
    "image_small": "https://api.deezer.com/artist/892/image",
    "email": "coldplay@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "4gzpq5DPGx6KlJUAGlLeqs",
      "name": "Coldplay",
      "images": [
        {
          "url": "https://api.deezer.com/artist/892/image"
        },
        {
          "url": "https://api.deezer.com/artist/892/image"
        },
        {
          "url": "https://api.deezer.com/artist/892/image"
        }
      ],
      "popularity": 91,
      "followers": {
        "total": 58000000
      }
    },
    "deezer_details": {
      "id": 892,
      "name": "Coldplay",
      "nb_album": 20,
      "nb_fan": 43500000,
      "picture_small": "https://api.deezer.com/artist/892/image",
      "picture_medium": "https://api.deezer.com/artist/892/image",
      "picture_big": "https://api.deezer.com/artist/892/image",
      "picture_xl": "https://api.deezer.com/artist/892/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000QKGN8W",
          "name": "Coldplay",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/815YdxgGQDL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 11,
    "name": "Eminem",
    "amazon_music_identifier": "B000S2JA4W",
    "apple_identifier": "111051",
    "deezer_identifier": "13",
    "spotify_identifier": "7dGJo4pcD2V6oG8kP0tJRR",
    "popularity": 90,
    "followers": 109723404,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eba00b11c129b27a88fc72f36b",
    "image_small": "https://i.scdn.co/image/ab6761610000f178a00b11c129b27a88fc72f36b",
    "email": "eminem@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "7dGJo4pcD2V6oG8kP0tJRR",
      "name": "Eminem",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eba00b11c129b27a88fc72f36b"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178a00b11c129b27a88fc72f36b"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178a00b11c129b27a88fc72f36b"
        }
      ],
      "popularity": 90,
      "followers": {
        "total": 109723404
      }
    },
    "deezer_details": {
      "id": 13,
      "name": "Eminem",
      "nb_album": 20,
      "nb_fan": 72000000,
      "picture_small": "https://api.deezer.com/artist/13/image",
      "picture_medium": "https://api.deezer.com/artist/13/image",
      "picture_big": "https://api.deezer.com/artist/13/image",
      "picture_xl": "https://api.deezer.com/artist/13/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000S2JA4W",
          "name": "Eminem",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/61mgDSEvjrL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 12,
    "name": "Beyonc\u00e9",
    "amazon_music_identifier": "B000T2D81C",
    "apple_identifier": "1419227",
    "deezer_identifier": "289",
    "spotify_identifier": "6vWDO969PvNqNYHIOW5v0m",
    "popularity": 86,
    "followers": 42766752,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb7eaa373538359164b843f7c0",
    "image_small": "https://i.scdn.co/image/ab6761610000f1787eaa373538359164b843f7c0",
    "email": "beyonce@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "6vWDO969PvNqNYHIOW5v0m",
      "name": "Beyonc\u00e9",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb7eaa373538359164b843f7c0"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1787eaa373538359164b843f7c0"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1787eaa373538359164b843f7c0"
        }
      ],
      "popularity": 86,
      "followers": {
        "total": 42766752
      }
    },
    "deezer_details": {
      "id": 289,
      "name": "Beyonc\u00e9",
      "nb_album": 20,
      "nb_fan": 30750000,
      "picture_small": "https://api.deezer.com/artist/289/image",
      "picture_medium": "https://api.deezer.com/artist/289/image",
      "picture_big": "https://api.deezer.com/artist/289/image",
      "picture_xl": "https://api.deezer.com/artist/289/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000T2D81C",
          "name": "Beyonc\u00e9",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81MAJ7T-GxL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 13,
    "name": "Rihanna",
    "amazon_music_identifier": "B00136BNZ2",
    "apple_identifier": "63346553",
    "deezer_identifier": "371032",
    "spotify_identifier": "5pKCCKE2ajJHZ9SAqPR9eC",
    "popularity": 88,
    "followers": 66000000,
    "image_big": "https://api.deezer.com/artist/371032/image",
    "image_small": "https://api.deezer.com/artist/371032/image",
    "email": "rihanna@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "5pKCCKE2ajJHZ9SAqPR9eC",
      "name": "Rihanna",
      "images": [],
      "popularity": 88,
      "followers": {
        "total": 66000000
      }
    },
    "deezer_details": {
      "id": 371032,
      "name": "Rihanna",
      "nb_album": 20,
      "nb_fan": 49500000,
      "picture_small": "https://api.deezer.com/artist/371032/image",
      "picture_medium": "https://api.deezer.com/artist/371032/image",
      "picture_big": "https://api.deezer.com/artist/371032/image",
      "picture_xl": "https://api.deezer.com/artist/371032/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00136BNZ2",
          "name": "Rihanna",
          "images": []
        }
      }
    }
  },
  {
    "id": 14,
    "name": "Post Malone",
    "amazon_music_identifier": "B07628JTDW",
    "apple_identifier": "966309175",
    "deezer_identifier": "9982462",
    "spotify_identifier": "246dkjiz0FB0Gaa75bh2hM",
    "popularity": 87,
    "followers": 47000000,
    "image_big": "https://api.deezer.com/artist/9982462/image",
    "image_small": "https://api.deezer.com/artist/9982462/image",
    "email": "post.malone@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "246dkjiz0FB0Gaa75bh2hM",
      "name": "Post Malone",
      "images": [],
      "popularity": 87,
      "followers": {
        "total": 47000000
      }
    },
    "deezer_details": {
      "id": 9982462,
      "name": "Post Malone",
      "nb_album": 20,
      "nb_fan": 35250000,
      "picture_small": "https://api.deezer.com/artist/9982462/image",
      "picture_medium": "https://api.deezer.com/artist/9982462/image",
      "picture_big": "https://api.deezer.com/artist/9982462/image",
      "picture_xl": "https://api.deezer.com/artist/9982462/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B07628JTDW",
          "name": "Post Malone",
          "images": []
        }
      }
    }
  },
  {
    "id": 15,
    "name": "Kanye West",
    "amazon_music_identifier": "B000QJO0ZQ",
    "apple_identifier": "2715720",
    "deezer_identifier": "230",
    "spotify_identifier": "5K4W6rqBFWDnAN6FQUkS6x",
    "popularity": 93,
    "followers": 33333325,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb6e835a500e791bf9c27a422a",
    "image_small": "https://i.scdn.co/image/ab6761610000f1786e835a500e791bf9c27a422a",
    "email": "kanye.west@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "5K4W6rqBFWDnAN6FQUkS6x",
      "name": "Kanye West",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb6e835a500e791bf9c27a422a"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1786e835a500e791bf9c27a422a"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1786e835a500e791bf9c27a422a"
        }
      ],
      "popularity": 93,
      "followers": {
        "total": 33333325
      }
    },
    "deezer_details": {
      "id": 230,
      "name": "Kanye West",
      "nb_album": 20,
      "nb_fan": 21750000,
      "picture_small": "https://api.deezer.com/artist/230/image",
      "picture_medium": "https://api.deezer.com/artist/230/image",
      "picture_big": "https://api.deezer.com/artist/230/image",
      "picture_xl": "https://api.deezer.com/artist/230/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000QJO0ZQ",
          "name": "Kanye West",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71w7GAs8SeL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 16,
    "name": "Kendrick Lamar",
    "amazon_music_identifier": "B00J2BEFEE",
    "apple_identifier": "368183298",
    "deezer_identifier": "4051926",
    "spotify_identifier": "2YZyLoL8PL0op8lr6KWiTW",
    "popularity": 85,
    "followers": 42000000,
    "image_big": "https://api.deezer.com/artist/4051926/image",
    "image_small": "https://api.deezer.com/artist/4051926/image",
    "email": "kendrick.lamar@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "2YZyLoL8PL0op8lr6KWiTW",
      "name": "Kendrick Lamar",
      "images": [],
      "popularity": 85,
      "followers": {
        "total": 42000000
      }
    },
    "deezer_details": {
      "id": 4051926,
      "name": "Kendrick Lamar",
      "nb_album": 20,
      "nb_fan": 31500000,
      "picture_small": "https://api.deezer.com/artist/4051926/image",
      "picture_medium": "https://api.deezer.com/artist/4051926/image",
      "picture_big": "https://api.deezer.com/artist/4051926/image",
      "picture_xl": "https://api.deezer.com/artist/4051926/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00J2BEFEE",
          "name": "Kendrick Lamar",
          "images": []
        }
      }
    }
  },
  {
    "id": 17,
    "name": "Travis Scott",
    "amazon_music_identifier": "B01LYWEGG8",
    "apple_identifier": "549236696",
    "deezer_identifier": "5440386",
    "spotify_identifier": "0Y5tJX1MQlFpXR87V87j5N",
    "popularity": 84,
    "followers": 39000000,
    "image_big": "https://api.deezer.com/artist/5440386/image",
    "image_small": "https://api.deezer.com/artist/5440386/image",
    "email": "travis.scott@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "0Y5tJX1MQlFpXR87V87j5N",
      "name": "Travis Scott",
      "images": [],
      "popularity": 84,
      "followers": {
        "total": 39000000
      }
    },
    "deezer_details": {
      "id": 5440386,
      "name": "Travis Scott",
      "nb_album": 20,
      "nb_fan": 29250000,
      "picture_small": "https://api.deezer.com/artist/5440386/image",
      "picture_medium": "https://api.deezer.com/artist/5440386/image",
      "picture_big": "https://api.deezer.com/artist/5440386/image",
      "picture_xl": "https://api.deezer.com/artist/5440386/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B01LYWEGG8",
          "name": "Travis Scott",
          "images": []
        }
      }
    }
  },
  {
    "id": 18,
    "name": "Lady Gaga",
    "amazon_music_identifier": "B001B45UQ2",
    "apple_identifier": "277293880",
    "deezer_identifier": "7545448",
    "spotify_identifier": "1HY2Jd0NmPuamShArHVU7n",
    "popularity": 83,
    "followers": 38000000,
    "image_big": "https://api.deezer.com/artist/7545448/image",
    "image_small": "https://api.deezer.com/artist/7545448/image",
    "email": "lady.gaga@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1HY2Jd0NmPuamShArHVU7n",
      "name": "Lady Gaga",
      "images": [],
      "popularity": 83,
      "followers": {
        "total": 38000000
      }
    },
    "deezer_details": {
      "id": 7545448,
      "name": "Lady Gaga",
      "nb_album": 20,
      "nb_fan": 28500000,
      "picture_small": "https://api.deezer.com/artist/7545448/image",
      "picture_medium": "https://api.deezer.com/artist/7545448/image",
      "picture_big": "https://api.deezer.com/artist/7545448/image",
      "picture_xl": "https://api.deezer.com/artist/7545448/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B001B45UQ2",
          "name": "Lady Gaga",
          "images": []
        }
      }
    }
  },
  {
    "id": 19,
    "name": "Dua Lipa",
    "amazon_music_identifier": "B0143OIF9G",
    "apple_identifier": "1031397873",
    "deezer_identifier": "8706544",
    "spotify_identifier": "6M2wZ9GZgrQXHCFfjv46we",
    "popularity": 86,
    "followers": 48078323,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb0c68f6c95232e716f0abee8d",
    "image_small": "https://i.scdn.co/image/ab6761610000f1780c68f6c95232e716f0abee8d",
    "email": "dua.lipa@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "6M2wZ9GZgrQXHCFfjv46we",
      "name": "Dua Lipa",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb0c68f6c95232e716f0abee8d"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1780c68f6c95232e716f0abee8d"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1780c68f6c95232e716f0abee8d"
        }
      ],
      "popularity": 86,
      "followers": {
        "total": 48078323
      }
    },
    "deezer_details": {
      "id": 8706544,
      "name": "Dua Lipa",
      "nb_album": 20,
      "nb_fan": 34500000,
      "picture_small": "https://api.deezer.com/artist/8706544/image",
      "picture_medium": "https://api.deezer.com/artist/8706544/image",
      "picture_big": "https://api.deezer.com/artist/8706544/image",
      "picture_xl": "https://api.deezer.com/artist/8706544/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0143OIF9G",
          "name": "Dua Lipa",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/415Ow6wgkrL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 20,
    "name": "Harry Styles",
    "amazon_music_identifier": "B006021BK0",
    "apple_identifier": "471260289",
    "deezer_identifier": "1055906",
    "spotify_identifier": "6KImCVD70vtIoJWnq6nGn3",
    "popularity": 89,
    "followers": 35371829,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebe309f8c3056a59f20d0968ca",
    "image_small": "https://i.scdn.co/image/ab6761610000f178e309f8c3056a59f20d0968ca",
    "email": "harry.styles@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "6KImCVD70vtIoJWnq6nGn3",
      "name": "Harry Styles",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebe309f8c3056a59f20d0968ca"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178e309f8c3056a59f20d0968ca"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178e309f8c3056a59f20d0968ca"
        }
      ],
      "popularity": 89,
      "followers": {
        "total": 35371829
      }
    },
    "deezer_details": {
      "id": 1055906,
      "name": "Harry Styles",
      "nb_album": 20,
      "nb_fan": 30000000,
      "picture_small": "https://api.deezer.com/artist/1055906/image",
      "picture_medium": "https://api.deezer.com/artist/1055906/image",
      "picture_big": "https://api.deezer.com/artist/1055906/image",
      "picture_xl": "https://api.deezer.com/artist/1055906/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B006021BK0",
          "name": "Harry Styles",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81XhkH6PolL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 21,
    "name": "Olivia Rodrigo",
    "amazon_music_identifier": "B08R5BBZB6",
    "apple_identifier": "979458609",
    "deezer_identifier": "14372080",
    "spotify_identifier": "1McMsnCxnFWFMLzHLxjRSN",
    "popularity": 80,
    "followers": 44000000,
    "image_big": "https://api.deezer.com/artist/14372080/image",
    "image_small": "https://api.deezer.com/artist/14372080/image",
    "email": "olivia.rodrigo@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1McMsnCxnFWFMLzHLxjRSN",
      "name": "Olivia Rodrigo",
      "images": [],
      "popularity": 80,
      "followers": {
        "total": 44000000
      }
    },
    "deezer_details": {
      "id": 14372080,
      "name": "Olivia Rodrigo",
      "nb_album": 20,
      "nb_fan": 33000000,
      "picture_small": "https://api.deezer.com/artist/14372080/image",
      "picture_medium": "https://api.deezer.com/artist/14372080/image",
      "picture_big": "https://api.deezer.com/artist/14372080/image",
      "picture_xl": "https://api.deezer.com/artist/14372080/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B08R5BBZB6",
          "name": "Olivia Rodrigo",
          "images": []
        }
      }
    }
  },
  {
    "id": 22,
    "name": "Shakira",
    "amazon_music_identifier": "B0000024CE",
    "apple_identifier": "889327",
    "deezer_identifier": "555",
    "spotify_identifier": "0EmeFodw0yg6iyo2txHssh",
    "popularity": 79,
    "followers": 37000000,
    "image_big": "https://api.deezer.com/artist/555/image",
    "image_small": "https://api.deezer.com/artist/555/image",
    "email": "shakira@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "0EmeFodw0yg6iyo2txHssh",
      "name": "Shakira",
      "images": [],
      "popularity": 79,
      "followers": {
        "total": 37000000
      }
    },
    "deezer_details": {
      "id": 555,
      "name": "Shakira",
      "nb_album": 20,
      "nb_fan": 27750000,
      "picture_small": "https://api.deezer.com/artist/555/image",
      "picture_medium": "https://api.deezer.com/artist/555/image",
      "picture_big": "https://api.deezer.com/artist/555/image",
      "picture_xl": "https://api.deezer.com/artist/555/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0000024CE",
          "name": "Shakira",
          "images": []
        }
      }
    }
  },
  {
    "id": 23,
    "name": "J Balvin",
    "amazon_music_identifier": "B00567V2L8",
    "apple_identifier": "444520760",
    "deezer_identifier": "5284696",
    "spotify_identifier": "1vyhD5VmyZ7KMfW5gqLgo5",
    "popularity": 89,
    "followers": 40976825,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb0405b03342c2e56751b9923d",
    "image_small": "https://i.scdn.co/image/ab6761610000f1780405b03342c2e56751b9923d",
    "email": "j.balvin@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1vyhD5VmyZ7KMfW5gqLgo5",
      "name": "J Balvin",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb0405b03342c2e56751b9923d"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1780405b03342c2e56751b9923d"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1780405b03342c2e56751b9923d"
        }
      ],
      "popularity": 89,
      "followers": {
        "total": 40976825
      }
    },
    "deezer_details": {
      "id": 5284696,
      "name": "J Balvin",
      "nb_album": 20,
      "nb_fan": 27000000,
      "picture_small": "https://api.deezer.com/artist/5284696/image",
      "picture_medium": "https://api.deezer.com/artist/5284696/image",
      "picture_big": "https://api.deezer.com/artist/5284696/image",
      "picture_xl": "https://api.deezer.com/artist/5284696/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00567V2L8",
          "name": "J Balvin",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81FZd+OR5tL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 24,
    "name": "SZA",
    "amazon_music_identifier": "B0757Z2VNF",
    "apple_identifier": "605800394",
    "deezer_identifier": "8279708",
    "spotify_identifier": "4tZwfgrUnJaIvOHi8RJjeU",
    "popularity": 77,
    "followers": 28000000,
    "image_big": "https://api.deezer.com/artist/8279708/image",
    "image_small": "https://api.deezer.com/artist/8279708/image",
    "email": "sza@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "4tZwfgrUnJaIvOHi8RJjeU",
      "name": "SZA",
      "images": [],
      "popularity": 77,
      "followers": {
        "total": 28000000
      }
    },
    "deezer_details": {
      "id": 8279708,
      "name": "SZA",
      "nb_album": 20,
      "nb_fan": 21000000,
      "picture_small": "https://api.deezer.com/artist/8279708/image",
      "picture_medium": "https://api.deezer.com/artist/8279708/image",
      "picture_big": "https://api.deezer.com/artist/8279708/image",
      "picture_xl": "https://api.deezer.com/artist/8279708/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0757Z2VNF",
          "name": "SZA",
          "images": []
        }
      }
    }
  },
  {
    "id": 25,
    "name": "Mariah Carey",
    "amazon_music_identifier": "B0000024YN",
    "apple_identifier": "91853",
    "deezer_identifier": "859",
    "spotify_identifier": "7GMtPWWO4WotZm87zH7O87",
    "popularity": 76,
    "followers": 14000000,
    "image_big": "https://api.deezer.com/artist/859/image",
    "image_small": "https://api.deezer.com/artist/859/image",
    "email": "mariah.carey@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "7GMtPWWO4WotZm87zH7O87",
      "name": "Mariah Carey",
      "images": [],
      "popularity": 76,
      "followers": {
        "total": 14000000
      }
    },
    "deezer_details": {
      "id": 859,
      "name": "Mariah Carey",
      "nb_album": 20,
      "nb_fan": 10500000,
      "picture_small": "https://api.deezer.com/artist/859/image",
      "picture_medium": "https://api.deezer.com/artist/859/image",
      "picture_big": "https://api.deezer.com/artist/859/image",
      "picture_xl": "https://api.deezer.com/artist/859/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0000024YN",
          "name": "Mariah Carey",
          "images": []
        }
      }
    }
  },
  {
    "id": 26,
    "name": "Adele",
    "amazon_music_identifier": "B0051X7ON6",
    "apple_identifier": "262836961",
    "deezer_identifier": "75798",
    "spotify_identifier": "4dpARuHxo51G3cvKYUfjfB",
    "popularity": 75,
    "followers": 61000000,
    "image_big": "https://api.deezer.com/artist/75798/image",
    "image_small": "https://api.deezer.com/artist/75798/image",
    "email": "adele@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "4dpARuHxo51G3cvKYUfjfB",
      "name": "Adele",
      "images": [],
      "popularity": 75,
      "followers": {
        "total": 61000000
      }
    },
    "deezer_details": {
      "id": 75798,
      "name": "Adele",
      "nb_album": 20,
      "nb_fan": 45750000,
      "picture_small": "https://api.deezer.com/artist/75798/image",
      "picture_medium": "https://api.deezer.com/artist/75798/image",
      "picture_big": "https://api.deezer.com/artist/75798/image",
      "picture_xl": "https://api.deezer.com/artist/75798/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0051X7ON6",
          "name": "Adele",
          "images": []
        }
      }
    }
  },
  {
    "id": 27,
    "name": "BTS",
    "amazon_music_identifier": "B0030248S0",
    "apple_identifier": "883131348",
    "deezer_identifier": "",
    "spotify_identifier": "3Nrfpe0tUJi4K4DXYWgMUX",
    "popularity": 97,
    "followers": 85756568,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebf80ec63ea7a0ef0fba60957d",
    "image_small": "https://i.scdn.co/image/ab6761610000f178f80ec63ea7a0ef0fba60957d",
    "email": "bts@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "3Nrfpe0tUJi4K4DXYWgMUX",
      "name": "BTS",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebf80ec63ea7a0ef0fba60957d"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178f80ec63ea7a0ef0fba60957d"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178f80ec63ea7a0ef0fba60957d"
        }
      ],
      "popularity": 97,
      "followers": {
        "total": 85756568
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0030248S0",
          "name": "BTS",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81R6UtE-WEL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 28,
    "name": "BLACKPINK",
    "amazon_music_identifier": "B01K9Q0AZ4",
    "apple_identifier": "1141774019",
    "deezer_identifier": "11706345",
    "spotify_identifier": "41MozSoPIsD1dJM0CLPjZF",
    "popularity": 81,
    "followers": 59255928,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb623538b7014238c54ceee056",
    "image_small": "https://i.scdn.co/image/ab6761610000f178623538b7014238c54ceee056",
    "email": "blackpink@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "41MozSoPIsD1dJM0CLPjZF",
      "name": "BLACKPINK",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb623538b7014238c54ceee056"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178623538b7014238c54ceee056"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178623538b7014238c54ceee056"
        }
      ],
      "popularity": 81,
      "followers": {
        "total": 59255928
      }
    },
    "deezer_details": {
      "id": 11706345,
      "name": "BLACKPINK",
      "nb_album": 20,
      "nb_fan": 39000000,
      "picture_small": "https://api.deezer.com/artist/11706345/image",
      "picture_medium": "https://api.deezer.com/artist/11706345/image",
      "picture_big": "https://api.deezer.com/artist/11706345/image",
      "picture_xl": "https://api.deezer.com/artist/11706345/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B01K9Q0AZ4",
          "name": "BLACKPINK",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71jXfcdeiKL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 29,
    "name": "Rauw Alejandro",
    "amazon_music_identifier": "B08L6ZJZ3J",
    "apple_identifier": "1107186883",
    "deezer_identifier": "14565429",
    "spotify_identifier": "1mcTU81sMhCAiLEiXXDWYd",
    "popularity": 72,
    "followers": 33000000,
    "image_big": "https://api.deezer.com/artist/14565429/image",
    "image_small": "https://api.deezer.com/artist/14565429/image",
    "email": "rauw.alejandro@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1mcTU81sMhCAiLEiXXDWYd",
      "name": "Rauw Alejandro",
      "images": [],
      "popularity": 72,
      "followers": {
        "total": 33000000
      }
    },
    "deezer_details": {
      "id": 14565429,
      "name": "Rauw Alejandro",
      "nb_album": 20,
      "nb_fan": 24750000,
      "picture_small": "https://api.deezer.com/artist/14565429/image",
      "picture_medium": "https://api.deezer.com/artist/14565429/image",
      "picture_big": "https://api.deezer.com/artist/14565429/image",
      "picture_xl": "https://api.deezer.com/artist/14565429/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B08L6ZJZ3J",
          "name": "Rauw Alejandro",
          "images": []
        }
      }
    }
  },
  {
    "id": 30,
    "name": "Feid",
    "amazon_music_identifier": "B000QK4UM8",
    "apple_identifier": "194502100",
    "deezer_identifier": "",
    "spotify_identifier": "2LRoIwlKmHjgvigdNGBHNo",
    "popularity": 87,
    "followers": 20205866,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb7e529f4ad13f86c69962cb12",
    "image_small": "https://i.scdn.co/image/ab6761610000f1787e529f4ad13f86c69962cb12",
    "email": "feid@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "2LRoIwlKmHjgvigdNGBHNo",
      "name": "Feid",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb7e529f4ad13f86c69962cb12"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1787e529f4ad13f86c69962cb12"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1787e529f4ad13f86c69962cb12"
        }
      ],
      "popularity": 87,
      "followers": {
        "total": 20205866
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000QK4UM8",
          "name": "FEID",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/41oOZ2hCArL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 31,
    "name": "Karol G",
    "amazon_music_identifier": "B00FN5IY46",
    "apple_identifier": "290814601",
    "deezer_identifier": "11044982",
    "spotify_identifier": "790FomKkXshlbRYZFtlgla",
    "popularity": 89,
    "followers": 64678999,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb66041ce9eb4497057cbc3496",
    "image_small": "https://i.scdn.co/image/ab6761610000f17866041ce9eb4497057cbc3496",
    "email": "karol.g@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "790FomKkXshlbRYZFtlgla",
      "name": "KAROL G",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb66041ce9eb4497057cbc3496"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17866041ce9eb4497057cbc3496"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17866041ce9eb4497057cbc3496"
        }
      ],
      "popularity": 89,
      "followers": {
        "total": 64678999
      }
    },
    "deezer_details": {
      "id": 11044982,
      "name": "Karol G",
      "nb_album": 20,
      "nb_fan": 26250000,
      "picture_small": "https://api.deezer.com/artist/11044982/image",
      "picture_medium": "https://api.deezer.com/artist/11044982/image",
      "picture_big": "https://api.deezer.com/artist/11044982/image",
      "picture_xl": "https://api.deezer.com/artist/11044982/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00FN5IY46",
          "name": "KAROL G",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81vRTJ2LgGL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 32,
    "name": "Shawn Mendes",
    "amazon_music_identifier": "B00ODAJN0S",
    "apple_identifier": "890403665",
    "deezer_identifier": "6476490",
    "spotify_identifier": "596o8kK8QGdOPqNNug3FDm",
    "popularity": 69,
    "followers": 45000000,
    "image_big": "https://api.deezer.com/artist/6476490/image",
    "image_small": "https://api.deezer.com/artist/6476490/image",
    "email": "shawn.mendes@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "596o8kK8QGdOPqNNug3FDm",
      "name": "Shawn Mendes",
      "images": [],
      "popularity": 69,
      "followers": {
        "total": 45000000
      }
    },
    "deezer_details": {
      "id": 6476490,
      "name": "Shawn Mendes",
      "nb_album": 20,
      "nb_fan": 33750000,
      "picture_small": "https://api.deezer.com/artist/6476490/image",
      "picture_medium": "https://api.deezer.com/artist/6476490/image",
      "picture_big": "https://api.deezer.com/artist/6476490/image",
      "picture_xl": "https://api.deezer.com/artist/6476490/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00ODAJN0S",
          "name": "Shawn Mendes",
          "images": []
        }
      }
    }
  },
  {
    "id": 33,
    "name": "Imagine Dragons",
    "amazon_music_identifier": "B003AM1Q94",
    "apple_identifier": "358714030",
    "deezer_identifier": "743700",
    "spotify_identifier": "53XhwfbYqKCa1cC15pYq2q",
    "popularity": 86,
    "followers": 59831765,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebab47d8dae2b24f5afe7f9d38",
    "image_small": "https://i.scdn.co/image/ab6761610000f178ab47d8dae2b24f5afe7f9d38",
    "email": "imagine.dragons@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "53XhwfbYqKCa1cC15pYq2q",
      "name": "Imagine Dragons",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebab47d8dae2b24f5afe7f9d38"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178ab47d8dae2b24f5afe7f9d38"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178ab47d8dae2b24f5afe7f9d38"
        }
      ],
      "popularity": 86,
      "followers": {
        "total": 59831765
      }
    },
    "deezer_details": {
      "id": 743700,
      "name": "Imagine Dragons",
      "nb_album": 20,
      "nb_fan": 42000000,
      "picture_small": "https://api.deezer.com/artist/743700/image",
      "picture_medium": "https://api.deezer.com/artist/743700/image",
      "picture_big": "https://api.deezer.com/artist/743700/image",
      "picture_xl": "https://api.deezer.com/artist/743700/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B003AM1Q94",
          "name": "Imagine Dragons",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71blzTWbHJL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 34,
    "name": "Maroon 5",
    "amazon_music_identifier": "B000TDZNWW",
    "apple_identifier": "1798556",
    "deezer_identifier": "893222",
    "spotify_identifier": "04gDigrS5kc0YWU3LCThmv",
    "popularity": 67,
    "followers": 43000000,
    "image_big": "https://api.deezer.com/artist/893222/image",
    "image_small": "https://api.deezer.com/artist/893222/image",
    "email": "maroon5@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "04gDigrS5kc0YWU3LCThmv",
      "name": "Maroon 5",
      "images": [],
      "popularity": 67,
      "followers": {
        "total": 43000000
      }
    },
    "deezer_details": {
      "id": 893222,
      "name": "Maroon 5",
      "nb_album": 20,
      "nb_fan": 32250000,
      "picture_small": "https://api.deezer.com/artist/893222/image",
      "picture_medium": "https://api.deezer.com/artist/893222/image",
      "picture_big": "https://api.deezer.com/artist/893222/image",
      "picture_xl": "https://api.deezer.com/artist/893222/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000TDZNWW",
          "name": "Maroon 5",
          "images": []
        }
      }
    }
  },
  {
    "id": 35,
    "name": "Twenty One Pilots",
    "amazon_music_identifier": "B01N0Z2X4S",
    "apple_identifier": "349736311",
    "deezer_identifier": "7093932",
    "spotify_identifier": "3YQKmKGau1PzlVlkL1I0wU",
    "popularity": 66,
    "followers": 31000000,
    "image_big": "https://api.deezer.com/artist/7093932/image",
    "image_small": "https://api.deezer.com/artist/7093932/image",
    "email": "twentyonepilots@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "3YQKmKGau1PzlVlkL1I0wU",
      "name": "Twenty One Pilots",
      "images": [],
      "popularity": 66,
      "followers": {
        "total": 31000000
      }
    },
    "deezer_details": {
      "id": 7093932,
      "name": "Twenty One Pilots",
      "nb_album": 20,
      "nb_fan": 23250000,
      "picture_small": "https://api.deezer.com/artist/7093932/image",
      "picture_medium": "https://api.deezer.com/artist/7093932/image",
      "picture_big": "https://api.deezer.com/artist/7093932/image",
      "picture_xl": "https://api.deezer.com/artist/7093932/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B01N0Z2X4S",
          "name": "Twenty One Pilots",
          "images": []
        }
      }
    }
  },
  {
    "id": 36,
    "name": "Lana Del Rey",
    "amazon_music_identifier": "B0051X7ON6",
    "apple_identifier": "464296584",
    "deezer_identifier": "1429612",
    "spotify_identifier": "00FQb4jTyjWxg8eyFRwdND",
    "popularity": 65,
    "followers": 27000000,
    "image_big": "https://api.deezer.com/artist/1429612/image",
    "image_small": "https://api.deezer.com/artist/1429612/image",
    "email": "lana.del.rey@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "00FQb4jTyjWxg8eyFRwdND",
      "name": "Lana Del Rey",
      "images": [],
      "popularity": 65,
      "followers": {
        "total": 27000000
      }
    },
    "deezer_details": {
      "id": 1429612,
      "name": "Lana Del Rey",
      "nb_album": 20,
      "nb_fan": 20250000,
      "picture_small": "https://api.deezer.com/artist/1429612/image",
      "picture_medium": "https://api.deezer.com/artist/1429612/image",
      "picture_big": "https://api.deezer.com/artist/1429612/image",
      "picture_xl": "https://api.deezer.com/artist/1429612/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0051X7ON6",
          "name": "Lana Del Rey",
          "images": []
        }
      }
    }
  },
  {
    "id": 37,
    "name": "Doja Cat",
    "amazon_music_identifier": "B00IUPTW5G",
    "apple_identifier": "830588310",
    "deezer_identifier": "10932734",
    "spotify_identifier": "5cj0lLjcoR7YOSnhnX0Po5",
    "popularity": 86,
    "followers": 37199616,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb8a0644455ebfa7d3976f5101",
    "image_small": "https://i.scdn.co/image/ab6761610000f1788a0644455ebfa7d3976f5101",
    "email": "doja.cat@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "5cj0lLjcoR7YOSnhnX0Po5",
      "name": "Doja Cat",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb8a0644455ebfa7d3976f5101"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1788a0644455ebfa7d3976f5101"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1788a0644455ebfa7d3976f5101"
        }
      ],
      "popularity": 86,
      "followers": {
        "total": 37199616
      }
    },
    "deezer_details": {
      "id": 10932734,
      "name": "Doja Cat",
      "nb_album": 20,
      "nb_fan": 21750000,
      "picture_small": "https://api.deezer.com/artist/10932734/image",
      "picture_medium": "https://api.deezer.com/artist/10932734/image",
      "picture_big": "https://api.deezer.com/artist/10932734/image",
      "picture_xl": "https://api.deezer.com/artist/10932734/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00IUPTW5G",
          "name": "Doja Cat",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/91lXf-XKUfL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 39,
    "name": "Chris Brown",
    "amazon_music_identifier": "B00136BNZ2",
    "apple_identifier": "95705522",
    "deezer_identifier": "5527684",
    "spotify_identifier": "7bXgB6jMjp9ATF7mmQLotW",
    "popularity": 62,
    "followers": 26000000,
    "image_big": "https://api.deezer.com/artist/5527684/image",
    "image_small": "https://api.deezer.com/artist/5527684/image",
    "email": "chris.brown@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "7bXgB6jMjp9ATF7mmQLotW",
      "name": "Chris Brown",
      "images": [],
      "popularity": 62,
      "followers": {
        "total": 26000000
      }
    },
    "deezer_details": {
      "id": 5527684,
      "name": "Chris Brown",
      "nb_album": 20,
      "nb_fan": 19500000,
      "picture_small": "https://api.deezer.com/artist/5527684/image",
      "picture_medium": "https://api.deezer.com/artist/5527684/image",
      "picture_big": "https://api.deezer.com/artist/5527684/image",
      "picture_xl": "https://api.deezer.com/artist/5527684/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00136BNZ2",
          "name": "Chris Brown",
          "images": []
        }
      }
    }
  },
  {
    "id": 41,
    "name": "Metro Boomin",
    "amazon_music_identifier": "B00DSZ2ICW",
    "apple_identifier": "670534462",
    "deezer_identifier": "10053820",
    "spotify_identifier": "0iEtIxbK0KxaSlF7G42ZOp",
    "popularity": 85,
    "followers": 12631513,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb28f1e72b31e756ea3f3a51e7",
    "image_small": "https://i.scdn.co/image/ab6761610000f17828f1e72b31e756ea3f3a51e7",
    "email": "metro.boomin@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "0iEtIxbK0KxaSlF7G42ZOp",
      "name": "Metro Boomin",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb28f1e72b31e756ea3f3a51e7"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17828f1e72b31e756ea3f3a51e7"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17828f1e72b31e756ea3f3a51e7"
        }
      ],
      "popularity": 85,
      "followers": {
        "total": 12631513
      }
    },
    "deezer_details": {
      "id": 10053820,
      "name": "Metro Boomin",
      "nb_album": 20,
      "nb_fan": 13500000,
      "picture_small": "https://api.deezer.com/artist/10053820/image",
      "picture_medium": "https://api.deezer.com/artist/10053820/image",
      "picture_big": "https://api.deezer.com/artist/10053820/image",
      "picture_xl": "https://api.deezer.com/artist/10053820/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00DSZ2ICW",
          "name": "Metro Boomin",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/91Zqcrqy9pL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 42,
    "name": "Peso Pluma",
    "amazon_music_identifier": "B082C6RXYG",
    "apple_identifier": "1500139475",
    "deezer_identifier": "145633762",
    "spotify_identifier": "12GqGscKJx3aE4t07u7eVZ",
    "popularity": 91,
    "followers": 27983042,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebe5283f5b671cf618b82a2696",
    "image_small": "https://i.scdn.co/image/ab6761610000f178e5283f5b671cf618b82a2696",
    "email": "peso.pluma@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "12GqGscKJx3aE4t07u7eVZ",
      "name": "Peso Pluma",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebe5283f5b671cf618b82a2696"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178e5283f5b671cf618b82a2696"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178e5283f5b671cf618b82a2696"
        }
      ],
      "popularity": 91,
      "followers": {
        "total": 27983042
      }
    },
    "deezer_details": {
      "id": 145633762,
      "name": "Peso Pluma",
      "nb_album": 20,
      "nb_fan": 18750000,
      "picture_small": "https://api.deezer.com/artist/145633762/image",
      "picture_medium": "https://api.deezer.com/artist/145633762/image",
      "picture_big": "https://api.deezer.com/artist/145633762/image",
      "picture_xl": "https://api.deezer.com/artist/145633762/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B082C6RXYG",
          "name": "Peso Pluma",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/61qKXcl8TcL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 43,
    "name": "Morgan Wallen",
    "amazon_music_identifier": "B00QNUADXK",
    "apple_identifier": "829142092",
    "deezer_identifier": "119757922",
    "spotify_identifier": "4oUHIQIBe0LHzYfvXNW4QM",
    "popularity": 90,
    "followers": 15489814,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb47de0bbc22f08b5ebe14bd6e",
    "image_small": "https://i.scdn.co/image/ab6761610000f17847de0bbc22f08b5ebe14bd6e",
    "email": "morgan.wallen@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "4oUHIQIBe0LHzYfvXNW4QM",
      "name": "Morgan Wallen",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb47de0bbc22f08b5ebe14bd6e"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17847de0bbc22f08b5ebe14bd6e"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17847de0bbc22f08b5ebe14bd6e"
        }
      ],
      "popularity": 90,
      "followers": {
        "total": 15489814
      }
    },
    "deezer_details": {
      "id": 119757922,
      "name": "Morgan Wallen",
      "nb_album": 20,
      "nb_fan": 11250000,
      "picture_small": "https://api.deezer.com/artist/119757922/image",
      "picture_medium": "https://api.deezer.com/artist/119757922/image",
      "picture_big": "https://api.deezer.com/artist/119757922/image",
      "picture_xl": "https://api.deezer.com/artist/119757922/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00QNUADXK",
          "name": "Morgan Wallen",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71K3EJ7a3uL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 44,
    "name": "Luke Combs",
    "amazon_music_identifier": "B00IAGXUC6",
    "apple_identifier": "815635315",
    "deezer_identifier": "89744562",
    "spotify_identifier": "718COspgdWOnwOFpJHRZHS",
    "popularity": 86,
    "followers": 14245552,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb147f54ed9d9d5f98efdfddd2",
    "image_small": "https://i.scdn.co/image/ab6761610000f178147f54ed9d9d5f98efdfddd2",
    "email": "luke.combs@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "718COspgdWOnwOFpJHRZHS",
      "name": "Luke Combs",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb147f54ed9d9d5f98efdfddd2"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178147f54ed9d9d5f98efdfddd2"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178147f54ed9d9d5f98efdfddd2"
        }
      ],
      "popularity": 86,
      "followers": {
        "total": 14245552
      }
    },
    "deezer_details": {
      "id": 89744562,
      "name": "Luke Combs",
      "nb_album": 20,
      "nb_fan": 9000000,
      "picture_small": "https://api.deezer.com/artist/89744562/image",
      "picture_medium": "https://api.deezer.com/artist/89744562/image",
      "picture_big": "https://api.deezer.com/artist/89744562/image",
      "picture_xl": "https://api.deezer.com/artist/89744562/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00IAGXUC6",
          "name": "Luke Combs",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/41n5T5-7zdL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 45,
    "name": "Sabrina Carpenter",
    "amazon_music_identifier": "B0041P77O2",
    "apple_identifier": "390647681",
    "deezer_identifier": "124716572",
    "spotify_identifier": "74KM79TiuVKeVCqs8QtB0B",
    "popularity": 90,
    "followers": 32440853,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb78e45cfa4697ce3c437cb455",
    "image_small": "https://i.scdn.co/image/ab6761610000f17878e45cfa4697ce3c437cb455",
    "email": "sabrina.carpenter@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "74KM79TiuVKeVCqs8QtB0B",
      "name": "Sabrina Carpenter",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb78e45cfa4697ce3c437cb455"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17878e45cfa4697ce3c437cb455"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17878e45cfa4697ce3c437cb455"
        }
      ],
      "popularity": 90,
      "followers": {
        "total": 32440853
      }
    },
    "deezer_details": {
      "id": 124716572,
      "name": "Sabrina Carpenter",
      "nb_album": 20,
      "nb_fan": 25500000,
      "picture_small": "https://api.deezer.com/artist/124716572/image",
      "picture_medium": "https://api.deezer.com/artist/124716572/image",
      "picture_big": "https://api.deezer.com/artist/124716572/image",
      "picture_xl": "https://api.deezer.com/artist/124716572/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0041P77O2",
          "name": "Sabrina Carpenter",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/91DDHQ-PhsL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 48,
    "name": "21 Savage",
    "amazon_music_identifier": "B07628JTDW",
    "apple_identifier": "894820464",
    "deezer_identifier": "10479435",
    "spotify_identifier": "1URnnhqYAYcrqrcwql10ft",
    "popularity": 85,
    "followers": 25619682,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb4f8f76117470957c0e81e5b2",
    "image_small": "https://i.scdn.co/image/ab6761610000f1784f8f76117470957c0e81e5b2",
    "email": "21.savage@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "1URnnhqYAYcrqrcwql10ft",
      "name": "21 Savage",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb4f8f76117470957c0e81e5b2"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1784f8f76117470957c0e81e5b2"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1784f8f76117470957c0e81e5b2"
        }
      ],
      "popularity": 85,
      "followers": {
        "total": 25619682
      }
    },
    "deezer_details": {
      "id": 10479435,
      "name": "21 Savage",
      "nb_album": 20,
      "nb_fan": 18000000,
      "picture_small": "https://api.deezer.com/artist/10479435/image",
      "picture_medium": "https://api.deezer.com/artist/10479435/image",
      "picture_big": "https://api.deezer.com/artist/10479435/image",
      "picture_xl": "https://api.deezer.com/artist/10479435/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B07628JTDW",
          "name": "21 Savage",
          "images": []
        }
      }
    }
  },
  {
    "id": 49,
    "name": "Lil Baby",
    "amazon_music_identifier": "B002802VHK",
    "apple_identifier": "1276656483",
    "deezer_identifier": "10947172",
    "spotify_identifier": "5f7VJjfbwm532GiveGC0ZK",
    "popularity": 86,
    "followers": 23158324,
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb514da623c55dc9d2155705dd",
    "image_small": "https://i.scdn.co/image/ab6761610000f178514da623c55dc9d2155705dd",
    "email": "lil.baby@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "spotify_details": {
      "id": "5f7VJjfbwm532GiveGC0ZK",
      "name": "Lil Baby",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb514da623c55dc9d2155705dd"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178514da623c55dc9d2155705dd"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178514da623c55dc9d2155705dd"
        }
      ],
      "popularity": 86,
      "followers": {
        "total": 23158324
      }
    },
    "deezer_details": {
      "id": 10947172,
      "name": "Lil Baby",
      "nb_album": 20,
      "nb_fan": 15000000,
      "picture_small": "https://api.deezer.com/artist/10947172/image",
      "picture_medium": "https://api.deezer.com/artist/10947172/image",
      "picture_big": "https://api.deezer.com/artist/10947172/image",
      "picture_xl": "https://api.deezer.com/artist/10947172/image"
    },
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B002802VHK",
          "name": "Lil Baby",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/81M1SS6nNUL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    }
  },
  {
    "id": 50,
    "name": "David Guetta",
    "amazon_music_identifier": "B000SXBQ0W",
    "apple_identifier": "5557599",
    "deezer_identifier": "",
    "spotify_identifier": "1Cs0zKBU1kc0i8ypK3B9ai",
    "popularity": 89,
    "followers": 27978670,
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebf150017ca69c8793503c2d4f",
    "image_small": "https://i.scdn.co/image/ab6761610000f178f150017ca69c8793503c2d4f",
    "email": "david.guetta@example.com",
    "can_be_deleted": true,
    "owner": "John Doe",
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000SXBQ0W",
          "name": "David Guetta",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71RmtiQqeBL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "spotify_details": {
      "id": "1Cs0zKBU1kc0i8ypK3B9ai",
      "name": "David Guetta",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebf150017ca69c8793503c2d4f"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178f150017ca69c8793503c2d4f"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178f150017ca69c8793503c2d4f"
        }
      ],
      "popularity": 89,
      "followers": {
        "total": 27978670
      }
    }
  },
  {
    "name": "Momina Mustehsan",
    "email": "momina@example.com",
    "spotify_identifier": "7J2gs5q2wLq6lU4q4wkyuV",
    "deezer_identifier": "",
    "amazon_music_identifier": "B0714LMHBX",
    "apple_identifier": "1150347363",
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebf4d6a04ac981e6981de335ad",
    "image_small": "https://i.scdn.co/image/ab6761610000f178f4d6a04ac981e6981de335ad",
    "followers": 846117,
    "popularity": 54,
    "spotify_details": {
      "id": "7J2gs5q2wLq6lU4q4wkyuV",
      "name": "Momina Mustehsan",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebf4d6a04ac981e6981de335ad"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178f4d6a04ac981e6981de335ad"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178f4d6a04ac981e6981de335ad"
        }
      ],
      "popularity": 54,
      "followers": {
        "total": 846117
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B0714LMHBX",
          "name": "Momina Mustehsan",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/711e0rF7aEL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 51,
    "can_be_deleted": true,
    "owner": "John Doe"
  },
  {
    "name": "Atif Aslam",
    "email": "atif.aslam@example.com",
    "spotify_identifier": "2oSONSC9zQ4UonDKnLqksx",
    "deezer_identifier": "",
    "amazon_music_identifier": "B002IFNZ7A",
    "apple_identifier": "300187267",
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebc40600e02356cc86f0debe84",
    "image_small": "https://i.scdn.co/image/ab6761610000f178c40600e02356cc86f0debe84",
    "followers": 45935437,
    "popularity": 79,
    "spotify_details": {
      "id": "2oSONSC9zQ4UonDKnLqksx",
      "name": "Atif Aslam",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebc40600e02356cc86f0debe84"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178c40600e02356cc86f0debe84"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178c40600e02356cc86f0debe84"
        }
      ],
      "popularity": 79,
      "followers": {
        "total": 45935437
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B002IFNZ7A",
          "name": "Atif Aslam",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/61eMEzdaK7L.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 52,
    "can_be_deleted": true,
    "owner": "John Doe"
  },
  {
    "name": "Deborah de Luca",
    "email": "deborah@example.com",
    "spotify_identifier": "144HzhpLjcR9k37w5Ico9B",
    "deezer_identifier": "",
    "amazon_music_identifier": "B005GI0T2U",
    "apple_identifier": "454571932",
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb69138e13a02ac4edde90ebe7",
    "image_small": "https://i.scdn.co/image/ab6761610000f17869138e13a02ac4edde90ebe7",
    "followers": 586014,
    "popularity": 52,
    "spotify_details": {
      "id": "144HzhpLjcR9k37w5Ico9B",
      "name": "Deborah de Luca",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb69138e13a02ac4edde90ebe7"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17869138e13a02ac4edde90ebe7"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f17869138e13a02ac4edde90ebe7"
        }
      ],
      "popularity": 52,
      "followers": {
        "total": 586014
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B005GI0T2U",
          "name": "Deborah de Luca",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/51fhmNn3o1L.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 53,
    "can_be_deleted": true,
    "owner": "John Doe"
  },
  {
    "name": "Carl Cox",
    "email": "carl.cox@example.com",
    "spotify_identifier": "19SmlbABtI4bXz864MLqOS",
    "deezer_identifier": "",
    "amazon_music_identifier": "B000T19KME",
    "apple_identifier": "2811492",
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebed8cecdfef719a807f258080",
    "image_small": "https://i.scdn.co/image/ab6761610000f178ed8cecdfef719a807f258080",
    "followers": 906132,
    "popularity": 53,
    "spotify_details": {
      "id": "19SmlbABtI4bXz864MLqOS",
      "name": "Carl Cox",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebed8cecdfef719a807f258080"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178ed8cecdfef719a807f258080"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178ed8cecdfef719a807f258080"
        }
      ],
      "popularity": 53,
      "followers": {
        "total": 906132
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B000T19KME",
          "name": "Carl Cox",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/91STUazhDnL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 54,
    "can_be_deleted": true,
    "owner": "John Doe"
  },
  {
    "name": "Karan Aujla",
    "email": "karan@example.com",
    "spotify_identifier": "6DARBhWbfcS9E4yJzcliqQ",
    "deezer_identifier": "",
    "amazon_music_identifier": "B00N63Q7JG",
    "apple_identifier": "914892130",
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb8a4c60d0eebe893f72e42979",
    "image_small": "https://i.scdn.co/image/ab6761610000f1788a4c60d0eebe893f72e42979",
    "followers": 28273941,
    "popularity": 80,
    "spotify_details": {
      "id": "6DARBhWbfcS9E4yJzcliqQ",
      "name": "Karan Aujla",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb8a4c60d0eebe893f72e42979"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1788a4c60d0eebe893f72e42979"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1788a4c60d0eebe893f72e42979"
        }
      ],
      "popularity": 80,
      "followers": {
        "total": 28273941
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00N63Q7JG",
          "name": "Karan Aujla",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/41TC2mTaLlL.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 55,
    "can_be_deleted": true,
    "owner": "John Doe"
  },
  {
    "name": "Quratulain Balouch",
    "email": "qb@example.com",
    "spotify_identifier": "5r3gdJkUB4oAcnuIGXEB7q",
    "deezer_identifier": "",
    "amazon_music_identifier": "B00E0FPDHQ",
    "apple_identifier": "675268309",
    "image_big": "https://i.scdn.co/image/ab6761610000e5eb1d8676325eed8d2c72ab4b49",
    "image_small": "https://i.scdn.co/image/ab6761610000f1781d8676325eed8d2c72ab4b49",
    "followers": 606619,
    "popularity": 51,
    "spotify_details": {
      "id": "5r3gdJkUB4oAcnuIGXEB7q",
      "name": "Quratulain Balouch",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5eb1d8676325eed8d2c72ab4b49"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1781d8676325eed8d2c72ab4b49"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f1781d8676325eed8d2c72ab4b49"
        }
      ],
      "popularity": 51,
      "followers": {
        "total": 606619
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B00E0FPDHQ",
          "name": "Quratulain Balouch",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/810fvCeBz5L.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 56,
    "can_be_deleted": true,
    "owner": "John Doe"
  },
  {
    "name": "Diljit Dosanjh",
    "email": "diljit@example.com",
    "spotify_identifier": "2FKWNmZWDBZR4dE5KX4plR",
    "deezer_identifier": "",
    "amazon_music_identifier": "B004PX1RYG",
    "apple_identifier": "423087540",
    "image_big": "https://i.scdn.co/image/ab6761610000e5ebfc043bea91ac91c222d235c9",
    "image_small": "https://i.scdn.co/image/ab6761610000f178fc043bea91ac91c222d235c9",
    "followers": 40362780,
    "popularity": 77,
    "spotify_details": {
      "id": "2FKWNmZWDBZR4dE5KX4plR",
      "name": "Diljit Dosanjh",
      "images": [
        {
          "url": "https://i.scdn.co/image/ab6761610000e5ebfc043bea91ac91c222d235c9"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178fc043bea91ac91c222d235c9"
        },
        {
          "url": "https://i.scdn.co/image/ab6761610000f178fc043bea91ac91c222d235c9"
        }
      ],
      "popularity": 77,
      "followers": {
        "total": 40362780
      }
    },
    "deezer_details": null,
    "amazon_music_details": {
      "data": {
        "artist": {
          "id": "B004PX1RYG",
          "name": "Diljit Dosanjh",
          "images": [
            {
              "url": "https://m.media-amazon.com/images/I/71I4Usoy42L.jpg",
              "imageType": "PROFILE",
              "height": 500,
              "width": 500
            }
          ]
        }
      }
    },
    "id": 57,
    "can_be_deleted": true,
    "owner": "John Doe"
  }
];

export default mockArtistsData.map(enrichArtistRow);
